export const InsideCameraModeDefinitions = [
  {
    value: 'driverManaged',
    details: 'Allows the driver to toggle the inside camera on/off by manually swipping up or down on the touch screen of the Xirgocam'
  },
  {
    value: 'off',
    details: 'Xirgocam will not record inside video. The driver cannot change this setting'
  }
]